module.exports = __webpack_public_path__ + "static/media/file-prescription.d1870f38.svg";